import * as Semantic from 'semantic-ui-react';
import * as React from 'react';
import { useFetchSynthesizedAudio } from 'api/v2/text2speechApi';
import { LanguageCode } from '@visikon/core-models/languageTypes';
import { Spinner } from 'components/spinner';

export default function Text2SpeechModal({
  text,
  activeLanguage,
  selectedVoiceId,
  onAttached,
  children,
}: {
  text: string;
  activeLanguage: LanguageCode;
  onAttached: (blob: Blob) => void;
  selectedVoiceId: string | undefined;
  children: JSX.Element;
}) {
  const [open, setOpen] = React.useState(false);
  const synthesizedSpeak = useFetchSynthesizedAudio({
    text,
    activeLanguage,
    selectedVoiceId,
    onSuccess: (blob) => {
      setOpen(false);
      onAttached(blob);
    },
  });

  const handleOpen = () => {
    synthesizedSpeak.mutate();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    synthesizedSpeak.reset();
  };

  return (
    <>
      <Semantic.Modal
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        trigger={children}
        style={{ height: '100%' }}
        basic
        dimmer="blurring"
        inverted="true"
      >
        <Spinner visible={synthesizedSpeak.isLoading} />
        {synthesizedSpeak.isError && (
          <Semantic.Message negative onDismiss={handleClose}>
            <Semantic.Message.Header>Failed to generate speech</Semantic.Message.Header>
            <p>{synthesizedSpeak.error instanceof Error ? synthesizedSpeak.error.message : 'An unknown error occurred'}</p>
          </Semantic.Message>
        )}
      </Semantic.Modal>
    </>
  );
}
